import LessonsList from "../../components/lessons/LessonsList";

const LessonsPage = () => {
     return(
          <>
          <LessonsList />
          </>
     )
};
export default  LessonsPage;